import { render, staticRenderFns } from "./cca-dashboard.vue?vue&type=template&id=5c69654e&scoped=true&"
import script from "./cca-dashboard.vue?vue&type=script&lang=js&"
export * from "./cca-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./cca-dashboard.vue?vue&type=style&index=0&id=5c69654e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c69654e",
  null
  
)

export default component.exports